import { EBarChart } from '@repo/ui';

import type { RevenuesMetricsResponseDto } from 'services/hooks/revenue';

import EmptyView from 'components/util/EmptyView';
import { Overlay } from 'components/util/Overlay';

import { useRevenueMetricsContext } from 'pages/dashboard/hooks/useRevenueMetricsContext';
import { transformForRevenueChart } from 'pages/dashboard/utils/transformForRevenueChart';

type RevenueChartProps = {
  data: RevenuesMetricsResponseDto;
  isBankAccountVerificationCompleted: boolean;
};

function RevenueChart({ data, isBankAccountVerificationCompleted }: RevenueChartProps) {
  const { period } = useRevenueMetricsContext();

  const metrics = isBankAccountVerificationCompleted ? transformForRevenueChart(data?.metrics, period) : [];

  return (
    <Overlay isEmpty={metrics.length === 0} emptyView={<EmptyView text="No more data" />}>
      <EBarChart metrics={metrics} />
    </Overlay>
  );
}
export default RevenueChart;
